// Import model
import { StartProjectAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartProjectAppointmentSendAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentSendAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentSendAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentSendAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentSendAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentSendAppointmentConfirmationEmailRequest');
    }


    const instance: StartProjectAppointmentSendAppointmentConfirmationEmailRequest = {
      description: obj['Description'] as string | undefined,
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
      message: obj['Message'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentSendAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentSendAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentSendAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentSendAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentSendAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentSendAppointmentConfirmationEmailRequest): any {
    return {
      'Description': instance.description,
      'UnlayerTemplateId': instance.unlayerTemplateId,
      'Message': instance.message,
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentSendAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentSendAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
